module.exports = __webpack_public_path__ + "files/4644d3ca4ac602f77d54f279ce7a7f83.png";